"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _editSavedFiltersDrawer = _interopRequireDefault(require("./edit-saved-filters-drawer"));
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
var _default = _editSavedFiltersDrawer.default;
var _default2 = _default;
exports.default = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(_default, "default", "/builds/audacious-inquiry/portfolio/prompt/prompt-application/clone/components/prompt-client/src/components/pages/notifications-page/edit-saved-filters-drawer/index.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJFZGl0U2F2ZWRGaWx0ZXJzRHJhd2VyIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcGFnZXMvbm90aWZpY2F0aW9ucy1wYWdlL2VkaXQtc2F2ZWQtZmlsdGVycy1kcmF3ZXIvaW5kZXguanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IEVkaXRTYXZlZEZpbHRlcnNEcmF3ZXIgZnJvbSAnLi9lZGl0LXNhdmVkLWZpbHRlcnMtZHJhd2VyJztcblxuZXhwb3J0IGRlZmF1bHQgRWRpdFNhdmVkRmlsdGVyc0RyYXdlcjtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBO0FBQWlFO0VBQUE7RUFBQTtBQUFBO0FBQUE7RUFBQTtBQUFBO0FBQUEsZUFFbERBLCtCQUFzQjtBQUFBO0FBQUE7QUFBQTtBQUFBO0VBQUE7RUFBQTtJQUFBO0VBQUE7RUFBQTtBQUFBO0FBQUE7QUFBQTtFQUFBO0VBQUE7QUFBQSJ9